<template>
  <div class="resize-panel">
     <ul class="view-change-panel">
      <li>View</li>
      <li @click="changeView('one')">
        <img :src="oneimg" alt="一个" :class="{'oneactive':this.viewType==='one'}">
      </li>
      <li @click="changeView('towX')">
        <img :src="towYimg" alt="竖二" :class="{'towYactive':this.viewType==='towX'}">
      </li>
      <li @click="changeView('towY')">
         <img :src="towXimg" alt="横二" :class="{'towXactive':this.viewType==='towY'}">
      </li>
      <li @click="changeView('full')">
         <img :src="fullimg" alt="四个" :class="{'fullactive':this.viewType==='full'}">
      </li>
    </ul>
    <div ref="resizePanel" class="resize-panel-box">
      <div class="left-top" :style="{width: lWidth, height: tHeight}">
        <!-- 右，下，右下 -->
        <resizeItem position="left-top" @changeSize="changeSize" :viewType="viewType">
          <slot name='left-top'></slot>
        </resizeItem>
      </div>
      <div class="right-top" :style="{width: rWidth, height: tHeight}" v-show="viewType == 'full' || viewType == 'towX'">
        <!-- 左，下，左下 -->
        <resizeItem position="right-top" @changeSize="changeSize" :viewType="viewType">
          <slot name='right-top'></slot>
        </resizeItem>
      </div>
      <div class="left-down" :style="{width: lWidth, height: dHeight}" v-show="viewType == 'full' || viewType == 'towY'">
        <!-- 右，上，右上 -->
        <resizeItem position="left-down" @changeSize="changeSize" :viewType="viewType">
          <slot name='left-down'></slot>
        </resizeItem>
      </div>
      <div class="right-down" :style="{width: rWidth, height: dHeight}" v-show="viewType == 'full'">
        <!-- 左，上，左上 -->
        <resizeItem position="right-down" @changeSize="changeSize" :viewType="viewType">
          <slot name='right-down'></slot>
        </resizeItem>
      </div>
    </div>
  </div>
</template>

<script>
import resizeItem from '@/components/resizeItem.vue'
export default {
  name: 'ResizePanel',
  data () {
    return {
      lWidth: '',
      rWidth: '',
      tHeight: '',
      dHeight: '',
      totalWidth: '',
      totalHeight: '',
      viewType: 'full',
      oneimg: require('@/assets/parts/icon/icon_view1.png'),
      towYimg: require('@/assets/parts/icon/icon_view_top2.png'),
      towXimg: require('@/assets/parts/icon/icon_view_left2.png'),
      fullimg: require('@/assets/parts/icon/icon_view4.png')

    }
  },
  props: {
    msg: String
  },
  mounted () {
    this.totalWidth = this.$refs.resizePanel.offsetWidth
    this.totalHeight = this.$refs.resizePanel.offsetHeight
    this.lWidth = this.rWidth = this.totalWidth * 0.5 + 'px'
    this.tHeight = this.dHeight = this.totalHeight * 0.5 + 'px'
    this.$nextTick(() => {
      this.$emit('resize')
    })
  },
  methods: {
    changeSize (data) {
      if (data.action !== 'yMove') {
        if (data.position === 'left-top' || data.position === 'left-down') {
          this.lWidth = data.widthData || this.lWidth
          this.rWidth = this.totalWidth - this.lWidth.split('px')[0] + 'px'
        } else if (data.position === 'right-top' || data.position === 'right-down') {
          this.rWidth = data.widthData || this.rWidth
          this.lWidth = this.totalWidth - this.rWidth.split('px')[0] + 'px'
        }
      }
      if (data.action !== 'xMove') {
        if (data.position === 'left-top' || data.position === 'right-top') {
          this.tHeight = data.heightData || this.tHeight
          this.dHeight = this.totalHeight - this.tHeight.split('px')[0] + 'px'
        } else if (data.position === 'right-down' || data.position === 'left-down') {
          this.dHeight = data.heightData || this.dHeight
          this.tHeight = this.totalHeight - this.dHeight.split('px')[0] + 'px'
        }
      }
      this.$emit('resize')
    },

    changeView (data) {
      this.viewType = data
      this.$nextTick(() => {
        this.$emit('resize')
      })
    }
  },
  components: {
    resizeItem
  },

  watch: {
    viewType (newValue, oldValue) {
      if (newValue === 'full') {
        this.lWidth = '50%'
        this.tHeight = '50%'
        this.rWidth = '50%'
        this.dHeight = '50%'
      } else if (newValue === 'towX') {
        this.lWidth = '50%'
        this.tHeight = '100%'
        this.rWidth = '50%'
        this.dHeight = '0px'
      } else if (newValue === 'towY') {
        this.lWidth = '100%'
        this.tHeight = '50%'
        this.rWidth = '0px'
        this.dHeight = '50%'
      } else if (newValue === 'one') {
        this.lWidth = '100%'
        this.tHeight = '100%'
        this.rWidth = '0px'
        this.dHeight = '0px'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  * {
    box-sizing: border-box;
  }

  .resize-panel {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .left-top {
    position: absolute;
    top: 0;
    left: 0
  }

  .right-top {
    position: absolute;
    top: 0;
    right: 0
  }

  .left-down {
    position: absolute;
    bottom: 0;
    left: 0
  }

  .right-down {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .view-change-panel {
    list-style: none;
    height: 31px;
    background: #bbbbbb;
    border-top: 2px solid #bdbdbd;
    border-right: 2px solid #bdbdbd;
    margin-top: -1px;
    margin-right: -1px;
  }

  .view-change-panel li {
    float: right;
    padding-right: 10px;
    line-height: 31px;
    font-weight: bold;
    font-size: 14px;
  }

  .view-change-panel li img {
    vertical-align: middle;
    cursor: pointer;
  }

  .view-change-panel li:nth-child(1) {
    float: left;
    padding-right: 0px;
    padding-left: 10px;
  }

  .resize-panel-box {
    height: calc(100% - 30px);
    position: relative;
  }

  .oneactive {
    background: url('../assets/parts/icon/icon_view1_selected.png') no-repeat;
  }

  .towYactive {
    background: url('../assets/parts/icon/icon_view_top2_selected.png') no-repeat;
  }

  .towXactive {
    background: url('../assets/parts/icon/icon_view_left2_selected.png') no-repeat;
  }

  .fullactive {
    background: url('../assets/parts/icon/icon_view4_selected.png') no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/resizePanel.vue